// eslint-disable-next-line no-unused-vars
function greeterInit () {
  $('#greeter-button').click(function () {
    const emailType = $('#rate-selection').val()
    window.location.href = '/builder?rateType=' + emailType
  })
}
